import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  fr: {
    nav: { menu: "Nos Plats", special: "Traiteur", location: "Nous Trouver", reserve: "Réserver" },
    heroKicker: "Restaurant Africain · Halal",
    heroTitle1: "Le Goût",
    heroTitle2: "du Fouta",
    heroTagline: "L'héritage culinaire de l'Afrique, servi au cœur de Paris.",
    open: "Ouvert 7j/7",
    hours: "de 11h00 à 00h00",
    heroCta: "Commander maintenant",
    heroCta2: "Voir le menu",
    halal: "Certifié Halal",
    madeIn: "Fait à Paris",
    marquee: "Thiep · Yassa · Maffé · Attiéké · Brochette · Fait maison · Halal · ",
    menuKicker: "01 — Nos Plats",
    menuTitle: "Le goût de l'Afrique,",
    menuTitleEm: "servi avec le cœur.",
    menuIntro: "Chaque plat est préparé le jour même, avec des produits frais et des épices rapportées du pays. Des portions généreuses, cuisinées comme à la maison.",
    perDish: "le plat",
    drinksKicker: "Boissons — Fait maison",
    drinksTitle: "Nos jus,",
    drinksTitleEm: "pressés maison.",
    drinksIntro: "Deux grands classiques d'Afrique de l'Ouest, préparés chaque jour sans additifs. À déguster sur place ou à emporter.",
    founderKicker: "Notre Histoire",
    founderTitle: "La femme derrière",
    founderTitleEm: "chaque saveur.",
    founderRole: "Fondatrice · Le Goût du Fouta",
    specialKicker: "02 — Commandes spéciales",
    specialTitle: "Vos grands jours méritent",
    specialTitleEm: "un grand festin.",
    specialIntro: "Nous préparons vos commandes sur mesure pour célébrer chaque moment important. Contactez-nous pour un devis personnalisé.",
    events: ["Anniversaires", "Mariages", "Baptêmes", "Fêtes de fin d'année"],
    specialCta: "Demander un devis",
    orderKicker: "03 — Sur place ou à emporter",
    orderTitle: "Deux façons de se régaler.",
    orderIntro: "Installez-vous dans notre salle chaleureuse ou emportez vos plats favoris. Appelez-nous ou commandez directement sur WhatsApp.",
    callBtn: "Appeler le restaurant",
    waBtn: "Commander sur WhatsApp",
    locKicker: "04 — Nous trouver",
    locTitle: "Au 18e, à deux pas du métro.",
    metroLabel: "Métro le plus proche",
    addressLabel: "Adresse",
    hoursLabel: "Horaires",
    directions: "Itinéraire",
    socialKicker: "05 — Sur TikTok",
    socialTitle: "Suivez la maison.",
    socialIntro: "Nouveaux plats, coulisses de la cuisine et événements — retrouvez-nous au quotidien.",
    followBtn: "Suivre sur TikTok",
    contactKicker: "06 — Réservation",
    contactTitle: "Réservez votre table.",
    contactIntro: "Remplissez le formulaire, nous poursuivons la conversation sur WhatsApp pour confirmer votre venue.",
    flyerKicker: "07 — L'Affiche",
    flyerTitle: "Notre affiche,",
    flyerTitleEm: "revisitée.",
    flyerIntro: "L'esprit de notre affiche de quartier, redessiné avec soin. Toutes nos infos essentielles réunies sur une belle carte — à partager sans modération.",
    flyerRestaurant: "Restaurant Africain",
    flyerCommande: "Possibilité de commande pour",
    flyerOnSite: "Plat sur place ou à emporter",
    flyerPrice: "Prix du plat en fonction de votre plat commandé",
    flyerShare: "Partager l'affiche",
    testiKicker: "08 — Ils en parlent",
    testiTitle: "Le goût qui",
    testiTitleEm: "fait revenir.",
    form: {
      name: "Votre nom",
      phone: "Téléphone",
      people: "Nombre de personnes",
      date: "Date",
      time: "Heure",
      message: "Un mot pour nous (optionnel)",
      submit: "Envoyer sur WhatsApp",
      sending: "Envoi…",
      sent: "Ouverture de WhatsApp…",
    },
    footerTagline: "Restaurant Africain Halal — Paris 18e.",
    rights: "Tous droits réservés.",
    waMessage: "Bonjour Le Goût du Fouta, je souhaite réserver une table.",
    waOrder: "Bonjour Le Goût du Fouta, je souhaite passer une commande.",
    waQuote: "Bonjour Le Goût du Fouta, je souhaite un devis pour un événement (anniversaire / mariage / baptême / fête).",
  },
  en: {
    nav: { menu: "Our Dishes", special: "Catering", location: "Find Us", reserve: "Book" },
    heroKicker: "African Restaurant · Halal",
    heroTitle1: "Le Goût",
    heroTitle2: "du Fouta",
    heroTagline: "Africa's culinary heritage, served in the heart of Paris.",
    open: "Open 7 days",
    hours: "11:00 AM — 12:00 AM",
    heroCta: "Order now",
    heroCta2: "See the menu",
    halal: "Halal Certified",
    madeIn: "Made in Paris",
    marquee: "Thiep · Yassa · Maffé · Attiéké · Brochette · Homemade · Halal · ",
    menuKicker: "01 — Our Dishes",
    menuTitle: "The taste of Africa,",
    menuTitleEm: "served with heart.",
    menuIntro: "Every dish is cooked fresh the same day, with produce and spices brought straight from home. Generous portions, made just like home cooking.",
    perDish: "per dish",
    drinksKicker: "Drinks — Homemade",
    drinksTitle: "Our juices,",
    drinksTitleEm: "pressed in-house.",
    drinksIntro: "Two great West African classics, made fresh every day with no additives. Enjoy in or takeaway.",
    founderKicker: "Our Story",
    founderTitle: "The woman behind",
    founderTitleEm: "every flavour.",
    founderRole: "Founder · Le Goût du Fouta",
    specialKicker: "02 — Special orders",
    specialTitle: "Your big days deserve",
    specialTitleEm: "a grand feast.",
    specialIntro: "We prepare bespoke orders to celebrate every important moment. Reach out for a personalised quote.",
    events: ["Birthdays", "Weddings", "Christenings", "Year-end parties"],
    specialCta: "Request a quote",
    orderKicker: "03 — Dine in or takeaway",
    orderTitle: "Two ways to feast.",
    orderIntro: "Settle into our warm dining room or take your favourites home. Call us or order straight on WhatsApp.",
    callBtn: "Call the restaurant",
    waBtn: "Order on WhatsApp",
    locKicker: "04 — Find us",
    locTitle: "In the 18th, steps from the metro.",
    metroLabel: "Nearest metro",
    addressLabel: "Address",
    hoursLabel: "Hours",
    directions: "Directions",
    socialKicker: "05 — On TikTok",
    socialTitle: "Follow the house.",
    socialIntro: "New dishes, kitchen behind-the-scenes and events — find us every day.",
    followBtn: "Follow on TikTok",
    contactKicker: "06 — Reservation",
    contactTitle: "Book your table.",
    contactIntro: "Fill in the form and we'll continue on WhatsApp to confirm your visit.",
    flyerKicker: "07 — The Poster",
    flyerTitle: "Our poster,",
    flyerTitleEm: "reimagined.",
    flyerIntro: "The spirit of our neighbourhood poster, carefully redrawn. Every essential detail on one elegant card — made to be shared.",
    flyerRestaurant: "African Restaurant",
    flyerCommande: "Catering available for",
    flyerOnSite: "Dine in or takeaway",
    flyerPrice: "Price depending on the dish you order",
    flyerShare: "Share the poster",
    testiKicker: "08 — Kind words",
    testiTitle: "The taste that",
    testiTitleEm: "brings them back.",
    form: {
      name: "Your name",
      phone: "Phone",
      people: "Number of guests",
      date: "Date",
      time: "Time",
      message: "A note for us (optional)",
      submit: "Send on WhatsApp",
      sending: "Sending…",
      sent: "Opening WhatsApp…",
    },
    footerTagline: "Halal African Restaurant — Paris 18th.",
    rights: "All rights reserved.",
    waMessage: "Hello Le Goût du Fouta, I would like to book a table.",
    waOrder: "Hello Le Goût du Fouta, I would like to place an order.",
    waQuote: "Hello Le Goût du Fouta, I would like a quote for an event (birthday / wedding / christening / party).",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const toggle = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
